export const concatStringsWithMiddleDot = (
  text: (string | null | undefined)[],
) => {
  const filteredText = text.filter((item) => !!item);

  if (filteredText.length === 0) {
    return null;
  }
  const joinedText = filteredText.join(' · ');
  return joinedText;
};
